import Layout from 'components/Layout';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import { ViewListIcon } from 'styles/icons';
import { useHistory } from 'react-router-dom';
/** componentes */
import HeaderSavePlus from '../../../components/Headers/SavePlus';
import Tabs, { TabsItem } from '../../../components/Tabs';
import { useHttp } from '../../../hooks/http';
import Section from './Section';
import SectionTwo from './SectionTwo';
import { Container } from './styles';

interface IRcols {
    id: string;
}

const Form: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { httpGet } = useHttp();
  const [rcols, setRcols] = useState({} as IRcols);
  const history = useHistory();

  const [active0, setActive0] = useState<any>();
  const [active1, setActive1] = useState<any>({ enable: false });

  useEffect(() => {
    setRcols({} as IRcols);
    async function loadRcols(): Promise<void> {
      const { status, data } = await httpGet(`/rcols/${id}`);
      if (status === 200) {
        setRcols(data);
        setActive1({ show: true });
        setActive0({ show: false });
      } else {
        history.push('/rcols');
      }
    }

    id ? loadRcols() : setActive0({ show: true });
    }, [id]);// eslint-disable-line

  const breadcrumbs = {
    icon: ViewListIcon,
    links: [{ path: '', title: 'LeiSeca Rcols' }],
  };

  return (
    <Layout breadcrumbs={breadcrumbs}>
      <Container>
        <HeaderSavePlus
          hiddenButton
          handlePlus={() => { }}
        >
          RCOLS - RELATÓRIO OPERACIONAL CIVIL
        </HeaderSavePlus>
        <Tabs>
          <TabsItem title="Seção I" {...active0}>
            <Section />
          </TabsItem>
          <TabsItem title="Seção II" {...active1}>
            <SectionTwo section={rcols} />
          </TabsItem>
        </Tabs>
      </Container>
    </Layout>
  );
};

export default Form;
